<template>
    <v-card :class="`convention-sections-menu ${mode}`" :elevation="mode == 'table' ? 0 : 3">
        <v-treeview
            :open-on-click="mode == 'content'"
            hoverable
            item-key="key"
            expand-icon="mdi-chevron-down"
            :open="mode == 'content' ? open : []"
            :active="mode == 'content' ? active : []"
            :items="items"
        >
            <template v-slot:label="{ item, open }">
                <convention-sections-menu-item
                    @active="setActive"
                    :ref="item.key"
                    :item="item"
                    :open="open"
                />
            </template>
        </v-treeview>
    </v-card>
</template>

<script>
import ConventionSectionsMenuItem from "./ConventionSectionsMenuItem.vue";
import { last, isArray } from "lodash";
import { EventBus } from "src/bus/eventBus";
import menuManager from "src/components/convention/managers/menuManager";

export default {
    components: { ConventionSectionsMenuItem },
    props: ["convention"],
    data() {
        return {
            mode: "table",
            items: [],
            open: [],
            active: [],
        };
    },
    mounted() {
        EventBus.$on("convention-section-title:scrolled", selectedIds => {
            if (isArray(selectedIds) && selectedIds.length <= 4) {
                this.open = selectedIds;
                const lastId = last(selectedIds);
                this.active = [lastId];
                this.$nextTick(() => this.checkPosition(lastId));
            }
        });

        EventBus.$on("convention-sections:updated", () => {
            this.items = menuManager.getItems(this.convention);
        });

        EventBus.$on("convention-sections:scrolled", mode => (this.mode = mode));
    },
    methods: {
        checkPosition(key) {
            if (this.$refs[key]) {
                const element = this.$refs[key].$el;
                const elementRect = element.getBoundingClientRect();
                const parentRect = this.$el.getBoundingClientRect();
                const py1 = parentRect.y + 10;
                const py2 = parentRect.y + parentRect.height - 10;
                const y = elementRect.y;
                const isVisible = py1 <= y && py2 >= y;
                if (!isVisible) {
                    const delta = y - py1 - 50;
                    this.$el.scrollTo(0, this.$el.scrollTop + delta);
                }
            }
        },
        setActive(id) {
            this.active = [id];
        },
    },
};
</script>

<style lang="sass">

.convention-sections-menu
    transition: none !important
    position: sticky
    top: 200px
    max-height: calc(100vh - 220px)
    overflow: auto
    +r(1400)
        top: 180px

    .v-treeview > .v-treeview-node
        & > .v-treeview-node__root
            border-bottom: 1px solid transparentize($color-secondary, .5)
        & > .v-treeview-node__children
            border-bottom: 1px solid transparentize($color-secondary, .5)

    .legend,
    .empty
        opacity: 0.3
        pointer-events: none

.convention-sections-menu.table
    background-color: transparent
    text-align: right
    .v-treeview > .v-treeview-node
        & > .v-treeview-node__root
            border-bottom: none
        .v-icon
            transition: none !important
            opacity: 0
            pointer-event: none
    .v-treeview .v-treeview-node__root
        min-height: 29px
        +r(1400)
            min-height: 24px
    .legend
        display: none

@media print
    .convention-sections-menu
        display: block
        position: absolute
        left: 0
        top: 0
        overflow: visible
        width: calc(30% - 3mm)
        text-align: right

        &.elevation-3
            background-color: transparent !important
            box-shadow: none !important
        .legend
            display: none

    .v-icon
        display: none !important

    .v-treeview-node + .v-treeview-node
        margin-top: 0.75mm

    .v-treeview-node__children
        display: none

    .v-treeview-node__content
        margin: 0 !important

    .v-treeview-node__root
        border: none !important
        min-height: 2mm !important
        padding: 0
        line-height: 1.5

        &::before
            display: none
</style>
